"use client"

import { normalizePublicPath } from "@lib/util/urls"
import Link from "next/link"
import React from "react"

/**
 * Storefront links are public root URLs; legacy default-country prefixes are
 * stripped before rendering.
 */
const LocalizedClientLink = ({
  children,
  href,
  ...props
}: {
  children?: React.ReactNode
  href: string
  className?: string
  onClick?: () => void
  passHref?: true
  [x: string]: unknown
}) => {
  const normalizedHref =
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("?") ||
    href.startsWith("#")
      ? href
      : normalizePublicPath(href)

  return (
    <Link href={normalizedHref} {...props}>
      {children}
    </Link>
  )
}

export default LocalizedClientLink
